import _typeof from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/typeof";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import config from '@/config';
var plugin = config.plugin;
export default (function (Vue) {
  for (var name in plugin) {
    var value = plugin[name];
    Vue.use(require("./".concat(name)).default, _typeof(value) === 'object' ? value : undefined);
  }
});